// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"324df75b","732":"e1f616e1","977":"9c14fe7e"}[chunkId] + ".chunk.js";
};